var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSendToWithdraw = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Hover/Action-Button/Send-to-Withdraw",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF00",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(2, 3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.2,4.46666667 L5.2,9.8 L6.8,9.8 L6.8,4.46666667 C6.8,2.74777775 8.23199997,1.35555556 10,1.35555556 C11.768,1.35555556 13.2,2.74777775 13.2,4.46666667 L13.2,6.80017808 L14,7.68888889 L14.8,6.80017808 L14.8,4.46666667 C14.8,1.89222227 12.648,-0.2 10,-0.2 C7.35200005,-0.2 5.2,1.89222227 5.2,4.46666667 Z",
    id: "Vector",
    fill: "#0A186E",
    fillRule: "nonzero",
    opacity: 0.99,
    transform: "translate(10, 4.8) rotate(90) translate(-10, -4.8)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#0A186E",
    x: 0,
    y: 3.48165941e-13,
    width: 6,
    height: 1.6,
    rx: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.0820536,8.77550824 L6.8,6.2 M9.0820536,8.77550824 L6.8,11.3510165",
    id: "Vector",
    stroke: "#0A186E",
    strokeWidth: 1.5,
    opacity: 0.99,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillRule: "nonzero",
    transform: "translate(7.941, 8.7755) rotate(-180) translate(-7.941, -8.7755)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "W",
    transform: "translate(2, 8)",
    fill: "#0A186E",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.43191197,5.45604396 L2.39752407,0 L3.07427785,0 L3.51169188,0.465659341 L2.47592847,6 L1.72077029,6 L1.43191197,5.45604396 Z M1.39889959,0 L2.21182944,5.49725275 L1.88995873,6 L1.01513067,6 L0,0 L1.39889959,0 Z M3.80055021,5.46840659 L4.60935351,0 L6,0 L4.98486933,6 L4.11416781,6 L3.80055021,5.46840659 Z M3.59009629,0 L4.58872077,5.48901099 L4.27922971,6 L3.52407153,6 L2.45942228,0.457417582 L2.91746905,0 L3.59009629,0 Z",
    id: "Shape"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSendToWithdraw);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Send-to-Withdraw.6b93b8e69bc3ca5de9c68aa9b325b716.svg";